export const MAX_THRESHOLD_PAGE_SIZE = 100;

export const SECONDARY_MAX_THRESHOLD_PAGE_SIZE = 50;

export const TERTIARY_MAX_THRESHOLD_PAGE_SIZE = 25;
